import { OutlinedInput, Stack, Typography } from '@mui/material'
import type React from 'react'
import type { ChangeEvent } from 'react'
import FormikErrorMessage from 'src/components/formikErrorMessage/FormikErrorMessage'
import type { TBaseFormRowProps } from './EditSchedule'

const ScheduleNameRow: React.FC<
  TBaseFormRowProps<{
    scheduleId: string
  }>
> = ({ setFieldValue, values: { name }, errors, touched }) => {
  const onScheduleNameChange = (e: ChangeEvent<HTMLInputElement>) =>
    setFieldValue('name', e.target.value)

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1">スケジュール名</Typography>
      <OutlinedInput
        fullWidth
        value={name}
        onChange={onScheduleNameChange}
        size="small"
      />
      <Typography variant="caption">※必須入力</Typography>

      <Stack>
        <FormikErrorMessage name="name" errors={errors} touched={touched} />
      </Stack>
    </Stack>
  )
}

export default ScheduleNameRow
